import { Injectable } from '@angular/core';
import * as wizeMobileApi from '@wize-mobile-api';
import { Observable, of } from 'rxjs';
import { switchMap, takeWhile } from 'rxjs/operators';
import { CountryMapper } from './country.mapper';
import { Store } from '@ngrx/store';
import { Country } from '@qvs/core';
import { selectIsAuthenticated } from '@qvs/core/auth';
import { loadCountries } from '~/modules/countries/slice/country.actions';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  constructor(
    private readonly store: Store,
    private readonly basicDataApi: wizeMobileApi.BasicDataMobileService
  ) {}

  public loadCountries(): Observable<Country[]> {
    return this.basicDataApi
      .listCountryDTO()
      .pipe(switchMap((wizeCountries) => of(CountryMapper.fromWizeCountries(wizeCountries))));
  }

  public init = () => {
    this.store
      .select(selectIsAuthenticated)
      .pipe(takeWhile((isAuthenticated) => isAuthenticated))
      .subscribe(() => {
        this.store.dispatch(loadCountries());
      });
  };
}
